import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, animate, style, transition } from '@angular/animations';
import { OutOrderDataSourceV3Service } from 'src/app/core/data-sources/v3/out-orders/out-order-data-source-v3.service';
import { EventType, ISellOrderEventHistory } from 'src/models/History';
import { toSellOrderEventHistoryItem } from '../../stock-details-modal/movement-details/to-event-history-item';

@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class OrderHistoryComponent implements OnInit {
  @Input() orderId: string;
  displayedColumns = ['action', 'eventName', 'taskType', 'user', 'deviceName', 'movedAt'];
  columnsDefinition = [
    { key: "eventName", text: "Tipo de evento" },
    { key: "taskType", text: "Tarefa" },
    { key: "user", text: "Usuário" },
    { key: "deviceName", text: "Equipamento" },
    { key: "movedAt", text: "Data do evento" },
  ];
  palletDetailDisplayedColumns = ['id', 'sku'];
  palletDetailColumnDefinition = [
    { key: 'id', text: 'Pallet' },
    { key: 'sku', text: 'Código do Item' }
  ];
  dataMovement: ISellOrderEventHistory[] = [];
  tableData: unknown[] = [];
  expandedElement: ISellOrderEventHistory | null;
  isLoading = true;
  EventType = EventType;

  constructor(private outOrderDataSourceV3Service: OutOrderDataSourceV3Service) { }

  ngOnInit(): void {
    this.getMovementHistory();
  }

  async getMovementHistory() {
    if (this.orderId) {
      this.dataMovement = await this.outOrderDataSourceV3Service.getFinishedOutOrderHistory(this.orderId);
    }

    this.tableData = this.dataMovement.map(element => toSellOrderEventHistoryItem(element));
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

}
